import { render, staticRenderFns } from "./OfflineRecallModal.vue?vue&type=template&id=edbdc5be"
import script from "./OfflineRecallModal.vue?vue&type=script&lang=js"
export * from "./OfflineRecallModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports